import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewClientSelectorComponent } from './new-client-selector.component';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ModalModule } from '../../../../controls/modal/modal.module';
import { DropdownModule } from '../../../../controls/dropdown/dropdown.module';
import { OptionModule } from '../../../../controls/option/option.module';
import { OverviewUtilitiesModule } from '../../../../shared/overview-utilities/overview-utilities.module';
import { PipesModule } from '../../../../shared/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    AutoCompleteModule,
    DropdownModule,
    OptionModule,
    OverviewUtilitiesModule,
    PipesModule,
  ],
  declarations: [NewClientSelectorComponent],
  exports: [NewClientSelectorComponent]
})
export class NewClientEstimateModule { }
